// @flow
/* eslint sort-keys: "error"*/

/**
 * Keep this in alphabetical order to avoid merge conflicts.
 * Name conventions:
 * - Use HA_SERP prefix for all tests
 * - Use FF suffix for feature flags
 * TODO: runtime configuration of these tests
 */
const TESTS = {
    HA_ADS_CONFIANT_TEST: 'HA_Ads_Confiant_Test',
    HA_ADS_HOLDBACK_SERP_AND_PDP: 'HA_Ads_Holdback_SERP_and_PDP',
    HA_ADS_NATIVE_UNIT_SERP_DESKTAB: 'HA_Ads_Native_Unit_SERP_DeskTab',
    HA_ADS_NATIVE_UNIT_SERP_MOBILE: 'HA_Ads_Native_Unit_SERP_Mobile',
    HA_ADS_SERP_RIGHTRAIL_300X600: 'HA_Ads_SERP_RightRail_300x600',
    HA_GDPR_BANNER: 'ha_gdpr_banner',
    HA_PULSE_TRIPBOARD_LOADING_ANIMATION_TEST:
        'ha_pulse_tripboard_loading_animation_test',
    HA_PULSE_TRIPBOARD_NEW_MODAL_TEST: 'ha_pulse_tripboard_new_modal_test',
    HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS: 'HA_SERP_ABACUS_PAYLOAD_LIVELAB_CSS',
    HA_SERP_DESKTOP_FILTER_BTN: 'HA_SERP_DESKTOP_FILTER_BTN',
    HA_SERP_FREE_CANCELLATION: 'HA_SERP_FREE_CANCELLATION',
    HA_SERP_HOVER_MAP_THUMBNAIL: 'HA_SERP_HOVER_MAP_THUMBNAIL',
    HA_SERP_MOBILE_HIT_HEADLINE: 'HA_SERP_MOBILE_HIT_HEADLINE',
    HA_SERP_NUMBER_OF_HITS: 'HA_SERP_NUMBER_OF_HITS',
    HA_SERP_PINNED_PROPERTY: 'HA_SERP_PINNED_PROPERTY',
    HA_SERP_PRICE_SUMMARY_FF: 'HA_SERP_PRICE_SUMMARY_FF',
    HA_SERP_SEARCH_TERM_CAROUSEL: 'HA_SERP_SEARCH_TERM_CAROUSEL',
    HA_SERP_THREE_PACK: 'HA_SERP_THREE_PACK',
    HA_SRS_SERIAL_PERCENT_BOOKED: 'HA_SRS_SERIAL_PERCENT_BOOKED',
    HA_TRAVSEG_SERP_AMENITIES: 'HA_TRAVSEG_SERP_AMENITIES',
    HA_TRAVSEG_SERP_FILTER: 'HA_TRAVSEG_SERP_FILTER',
    // GraphQL urgency messaging test for hits
    HA_URGENCY_HITCOUNT_MESSAGE_SERVICE_SCARCITY:
        'HA_URGENCY_HitCount_message_service_scarcity'
};
/* The below array evaluated with abacus client utils when this module is dispatched to redux to create the abacus state */
const EVALUATE = Object.values(TESTS);
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    ...TESTS
};
